import { useVehicleCollectionStatusSub } from 'Containers/app/vehicleCollection/hooks/useVehicleCollectionStatusSub';
import { useVehicleCollectionSub } from 'Containers/app/vehicleCollection/hooks/useVehicleCollectionSub';
import { FORBIDDEN_STATUS_CODES_FOR_VEHICLE_COLLECTION_PAGE } from 'Containers/app/vehicleCollection/utils/routeChecker';
import { COLLECTION_DETAILS_STATUSES_MAP } from 'Containers/app/vehicleCollection/VehicleCollectionSubjects';

export const useIsDealerDirect = () => {
  const { collectionDetails, offer, vrm } = useVehicleCollectionSub();
  const vehicleCollectionStatus = useVehicleCollectionStatusSub();

  const slug = offer?.state?.slug;

  const hasNotRequestedCollectionPreferences = (
    vehicleCollectionStatus === COLLECTION_DETAILS_STATUSES_MAP.COLLECTION_PREFERENCES_NOT_REQUESTED
  );

  const isCollectionDetailsNotFound = (
    collectionDetails?.statusCode?.current === FORBIDDEN_STATUS_CODES_FOR_VEHICLE_COLLECTION_PAGE
  );

  const isDealerDirect = (
    (slug && vrm && hasNotRequestedCollectionPreferences)
    || isCollectionDetailsNotFound
  );

  return isDealerDirect;
};
